import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2087cf',
    },
    secondary: {
      main: '#fff',
    },
    error: {
      main: '#ff2600',
    },
  },
})
